import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { OrdersCoServices } from '../../services';
import { Globals } from '../../../../globals';
import { TranslateService } from '@ngx-translate/core';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the TpvTicketMenuPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-orders-select-menu',
  templateUrl: 'orders-select-menu.html',
})
export class OrdersSelectMenuPage {

  max_menus: any;
  max_combo: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public ordersCoServices: OrdersCoServices,
    public globals: Globals,
    public translate: TranslateService) {

    this.max_menus = this.globals.checkLimitsByLicense('daily_menu', 'limit');
    this.max_combo = this.globals.checkLimitsByLicense('daily_menu', 'limit_combo');

    if (this.max_menus == -1) {
      this.max_menus = undefined;
    }
    if (this.max_combo == -1) {
      this.max_combo = undefined;
    }
  }

  ionViewDidLoad() {
  }

  styleAddon() {
    //get height screen
    var height = window.innerHeight - 75; //70 es la capcalera
    height = height / 2; //Div sections
    height = height - 130; //Div categories

    let styles = {
      'height': height + 'px',
      'width': 100 + '%',
      //'background-image': 'linear-gradient(89deg,#ff7a59,#f2547d)',
      'color': '#fff',
      'border-radius': '5px',
      'font-weight': 'bold',
      'overflow': 'hidden',
      'line-height': height + 'px',
      'text-align': 'center',
    };
    return styles;
  }

  back() {
    this.ordersCoServices.cleanVariables();
    this.navCtrl.pop();
  }

  changeCategorie(categorie) {
    this.ordersCoServices.selected_tag = 'all';
    this.ordersCoServices.section_select = categorie;
  }



  changeSelectTag(tag) {
    this.ordersCoServices.sendTagDish(tag);
    this.ordersCoServices.selected_tag = tag;
  }
  changeSelectTagProduct(tag) {
    this.ordersCoServices.sendTagProduct(tag);
    this.ordersCoServices.selected_tag = tag;
  }

  changeSelectMenuSelected(menu) {
    if (menu.style === 'combo') {
      this.ordersCoServices.is_combo = true;
    } else {
      this.ordersCoServices.is_combo = false;
    }

    this.ordersCoServices.section_menu_order = menu.sections[0].name;

    this.ordersCoServices.menu_select = menu.UID;
  }

  changeSelectMenuSelectedMobile(menu) {


    var data = menu.split(';,;');

    this.ordersCoServices.section_menu_order = data[0];

    this.ordersCoServices.menu_select = data[1];


    if (data[2] === 'combo') {
      this.ordersCoServices.is_combo = true;
    } else {
      this.ordersCoServices.is_combo = false;
    }

  }

  async openModSelect() {
    await this.ordersCoServices.openModSelect();
    this.ordersCoServices.count_elements = 0;//reset
    this.navCtrl.pop();
    this.navCtrl.pop();
  }

  openModalVersionPro() {
    this.navCtrl.push(AddonsTriggerVersionProPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/orders/orders-select/orders-select-menu/orders-select-menu.ts